import { render, staticRenderFns } from "./customer-rules.component.vue?vue&type=template&id=49d6f290&scoped=true&"
import script from "./customer-rules.component.ts?vue&type=script&lang=ts&"
export * from "./customer-rules.component.ts?vue&type=script&lang=ts&"
import style0 from "./customer-rules.component.scss?vue&type=style&index=0&id=49d6f290&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d6f290",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VDataTable})
